export interface StatsICECandidate extends Object{
    readonly ip: string | null
    readonly candidateType: string | null
    readonly protocol: string | null
    readonly port: number | null
    readonly relayProtocol: string | null
}

export interface StatsCandidatePair {
    localCandidate?: StatsICECandidate
    remoteCandidate?: StatsICECandidate
    state: RTCStatsIceCandidatePairState
}

const getIceCandidateFromStats = (stats: RTCStatsReport, id: string): StatsICECandidate | undefined => {
    if (stats.has(id)) {
        const candidate = stats.get(id) as StatsICECandidate
        return {
            ip: candidate.ip,
            candidateType: candidate.candidateType,
            protocol: candidate.protocol,
            port: candidate.port,
            relayProtocol: candidate.relayProtocol
        }
    }
}

export const getIceCandidatePairs = async (pc: RTCPeerConnection): Promise<StatsCandidatePair[]> => {
    const stats = await pc.getStats()
    return [...stats.values()]
        .filter((report: RTCStats) => report.type === 'candidate-pair')
        .map((report: RTCStats) => {
            const pairReport = report as RTCIceCandidatePairStats
            return {
                state: pairReport.state,
                localCandidate: getIceCandidateFromStats(stats, pairReport.localCandidateId),
                remoteCandidate: getIceCandidateFromStats(stats, pairReport.remoteCandidateId)
            }
    })
}
